import { FormProvider } from "react-hook-form";

import { Box } from "ui/box";
import { Button } from "ui/button";
import { Chip } from "ui/chip";
import { Tab, Tabs } from "ui/tabs";
import { ColorsTab } from "containers/admin/clients/client/theme-configuration-page/brand-identity/colors-tab/colors-tab";
import { FontsTab } from "containers/admin/clients/client/theme-configuration-page/brand-identity/fonts-tab/fonts-tab";
import { PublishButton } from "containers/admin/clients/client/theme-configuration-page/components/publish-button/publish-button";

import { useBrandIdentity } from "containers/admin/clients/client/theme-configuration-page/brand-identity/use-brand-identity";

import {
  ACTIONS_SX,
  CARD_SX,
  CONTENT_SX,
  HEADER_ROW_SX,
  HEADER_SX,
  PAGE_SX,
} from "containers/admin/clients/client/theme-configuration-page/brand-identity/brand-identity.styles";
import {
  BRAND_IDENTITY_FORM_ID,
  BRAND_IDENTITY_NOTICE,
  BRAND_IDENTITY_TABS,
} from "containers/admin/clients/client/theme-configuration-page/brand-identity/brand-identity.constants";

import Icons from "assets";

export const BrandIdentity = () => {
  const {
    form,
    activeTab,
    isEditing,
    isLoading,
    isSaving,
    unsavedChangesDialog,
    handleTabChange,
    handleEdit,
    handleCancel,
    handleSave,
  } = useBrandIdentity();

  return (
    <Box sx={PAGE_SX}>
      <Box component="section" aria-label="Brand identity" sx={CARD_SX}>
        <Box component="header" sx={HEADER_SX}>
          <Box sx={HEADER_ROW_SX}>
            <Chip size="small" icon={<Icons.InfoIndicator />} label={BRAND_IDENTITY_NOTICE} />
            <Box sx={ACTIONS_SX}>
              {isEditing ? (
                <>
                  <Button variant="text" size="large" onClick={handleCancel} disabled={isSaving}>
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    form={BRAND_IDENTITY_FORM_ID}
                    size="large"
                    loading={isSaving}
                    disabled={isSaving}>
                    Save changes
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    size="large"
                    onClick={handleEdit}
                    disabled={isLoading}>
                    Edit
                  </Button>
                  <PublishButton disabled={isLoading} />
                </>
              )}
            </Box>
          </Box>
          <Tabs
            appearance="sub-nav"
            value={activeTab}
            onChange={handleTabChange}
            aria-label="Brand identity sections">
            {BRAND_IDENTITY_TABS.map(({ value, label }) => (
              <Tab key={value} value={value} label={label} />
            ))}
          </Tabs>
        </Box>
        <FormProvider {...form}>
          <Box component="form" id={BRAND_IDENTITY_FORM_ID} onSubmit={handleSave} sx={CONTENT_SX}>
            {activeTab === "colors" ? (
              <ColorsTab isEditing={isEditing} isLoading={isLoading} />
            ) : (
              <FontsTab isEditing={isEditing} isLoading={isLoading} />
            )}
          </Box>
        </FormProvider>
      </Box>
      {unsavedChangesDialog}
    </Box>
  );
};
